module.exports=[
  {
    "vote": "Joker",
    "timestamp": "1/31/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "1/31/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "1/31/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "1/31/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "1/31/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "1/31/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "The Irishman",
    "timestamp": "1/31/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "1/31/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "1/31/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "1/31/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Irishman",
    "timestamp": "1/31/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "1/31/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "1/31/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "1/31/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Little Women",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "1/31/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "1/31/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/1/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/1/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Judy",
    "timestamp": "2/1/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/1/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/1/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/1/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": 1917,
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/3/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/3/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/3/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/3/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/4/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/4/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Ford V Ferrari ",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/5/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Joker",
    "timestamp": "2/5/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/5/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/5/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Todd Phillips"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Al Pacino"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Margot Robbie"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/6/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/6/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/6/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/6/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/6/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Quentin Tarantino"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Saoirse Ronan"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Adam Driver"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Martin Scorsese"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Richard Jewell",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Kathy Bates"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Leonardo DiCaprio"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Bombshell",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Charlize Theron"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Jonathan Pryce"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "A Beautiful Day in the Neighborhood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Tom Hanks"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Scarlett Johansson"
  },
  {
    "vote": "The Irishman",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Joe Pesci"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Little Women",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Florence Pugh"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Bong Joon Ho"
  },
  {
    "vote": "Harriet",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Cynthia Erivo"
  },
  {
    "vote": "Pain and Glory",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Antonio Banderas"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "The Two Popes",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Anthony Hopkins"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": "Jojo Rabbit",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Parasite",
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Director",
    "actor": "Sam Mendes"
  },
  {
    "vote": "Judy",
    "timestamp": "2/7/2020",
    "category": "Best Actress",
    "actor": "Renee Zellweger"
  },
  {
    "vote": "Joker",
    "timestamp": "2/7/2020",
    "category": "Best Actor",
    "actor": "Joaquin Phoenix"
  },
  {
    "vote": "Marriage Story",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actress",
    "actor": "Laura Dern"
  },
  {
    "vote": "Once Upon a Time...in Hollywood",
    "timestamp": "2/7/2020",
    "category": "Best Supporting Actor",
    "actor": "Brad Pitt"
  },
  {
    "vote": 1917,
    "timestamp": "2/7/2020",
    "category": "Best Picture",
    "actor": "cast"
  }
]